import { Component, OnInit } from '@angular/core';

import { AppComponent } from '../app.component';
import { HubService } from '../services/hub.service';
import { FirmwareDetails } from '../types/firmware-details';
import { FirmwareSet } from '../types/firmware-set';
import { SubMenuOption } from '../types/submenu-option';

@Component({
  selector: 'firmware-sets',
  template: `<div id="content">
  <sub-menu [options]="subMenu"></sub-menu>
<ul class="firmware-sets">
  <li>
    <span class="id">FWSetID</span>
    <span class="name">Set Name</span>
    <span class="version">Version</span>
    <span class="name">Version name</span>
  </li>
  <li *ngFor="let firmwareset of firmwareSets"
      class="firmware-set" (click)="toggleExpandRow(firmwareset.fwsetid)">
    <span class="id">{{ firmwareset.fwsetid }}</span>
    <span class="name">{{ firmwareset.name }}</span>
    <span *ngIf="firmwareset.fwsetid !== expandedSet; else expanded">
      <ng-container *ngIf="!!firmwareset.target_firmware_uid; else no_firmware">
        <span class="version">{{ firmwareset.major }}.{{ firmwareset.minor }}.{{ firmwareset.patch }}</span>
        <span class="name">{{ firmwareset.fw_name }}</span>
      </ng-container>
      <ng-template #no_firmware>
        <span class="version">-</span>
        <span class="name">No upgrade target available</span>
      </ng-template>
    </span>
    <ng-template #expanded>
      <firmware-set
        [inFirmwareSet]="firmwareset"
        [firmwares]="firmwares"
        (modsCompleted)="onSetClosed($event)"></firmware-set>
    </ng-template>
  </li>
  <li>
    <span class="number center"> &nbsp; </span>
  </li>
</ul>
</div>`,
  styleUrls: ['./firmware-sets.component.css'],
  providers: [HubService]
})

export class FirmwareSetsComponent implements OnInit {
  errorMessage: string;
  firmwares: Array<FirmwareDetails>;
  firmwareSets: Array<FirmwareSet>;
  expandedSet = 0;
  hasChanges = false;
  firmwareSet: FirmwareSet;
  subMenu: SubMenuOption[];
  private fwSetIndex: number[];

  constructor(
    private hubService: HubService
  ) {
    this.subMenu = [
      { route: '/firmwaresets', title: 'Firmware Sets' },
      { route: '/firmwares', title: 'Firmwares' },
    ];
  }

  ngOnInit(): void {
    if (!AppComponent.IsLoggedIn()) { return; }
    this.refreshFirmwareSets();
    try {
      this.hubService.getFirmwareDetails().subscribe(
        firmwares => this.firmwares = firmwares,
        error => this.errorMessage = <any>error,
      );
    } catch (e) {
      console.log('Meh: ' + e);
    }
    AppComponent.SetTitle('Firmware Routing');
  }

  // Called to request a refresh of the firmware sets on load / after write
  refreshFirmwareSets(): void {
    try {
      this.hubService.getFirmwareSets().subscribe(
        results => this.updateFirmwareSets(results),
        error => this.errorMessage = <any>error,
      );
    } catch (e) {
      console.log('Meh: ' + e);
    }
  }

  // Called after loading updated firmware sets to post process them
  updateFirmwareSets(newSets: FirmwareSet[]): void {
    try {
      let fwSetIndex = [];
      let i = 0;
      for (; i < newSets.length; i++) {
        fwSetIndex[newSets[i].fwsetid] = i;
      }
      this.fwSetIndex = fwSetIndex;
      this.firmwareSets = newSets;
      // console.log('Updating firmware Sets: ', newSets);
      // console.log('Updating firmware Index: ', fwSetIndex);
      // this.expandRow(this.firmwareSets[0].fwsetid);
    } catch (e) {
      console.log('Meh: ' + e);
    }
  }

  // toggleExpandRow expands the currently clicked row
  toggleExpandRow(fwsetid: number): void {
    if (this.expandedSet === fwsetid) {
      return;
    } else {
      this.expandedSet = fwsetid;
      this.firmwareSet = this.firmwareSets[this.fwSetIndex[fwsetid]];
    }
  }

  changed() {
    this.hasChanges = true;
  }

  cancel(): void {
    this.expandedSet = 0;
  }

  onSetClosed(saved: boolean): void {
    if (saved) {
      this.refreshFirmwareSets();
    }
  }

  save(): void {
    this.hubService.updateFirmwareSet(this.firmwareSet)
      .subscribe(
        () => {
          this.refreshFirmwareSets();
          this.hasChanges = false;
          this.firmwareSets[this.fwSetIndex[this.expandedSet]] = this.firmwareSet;
          this.expandedSet = 0;
        },
        e => this.errorMessage = e
      );
  }
}
